import {ChangeDetectionStrategy, Component} from '@angular/core';
import {RouterLink} from '@angular/router';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';

@Component({
  selector: 'app-administration-credentials-banner',
  templateUrl: './administration-credentials-banner.component.html',
  styleUrls: ['./administration-credentials-banner.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, MatIconModule, MatButtonModule]
})
export class AdministrationCredentialsBannerComponent {

  dismissed = false;

  dismiss(): void {
    this.dismissed = true;
  }
}
